import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=71a4479b&scoped=true&"
var script = {}
import style0 from "./Landing.vue?vue&type=style&index=0&id=71a4479b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a4479b",
  null
  
)

export default component.exports